<template>
  <div>
    <div class="container">
      <div class="row" style="text-align: center; margin-top: 148px">
        <div class="col-md-4">
          <div class="row">
            <div class="col-md-6">
              <img :src="userimg" alt class="personalcenter1" />
            </div>
            <div class="col-md-6" style="text-align: left; margin-left: -20px">
              <div class="row" style="font-size: 19px">{{ username }}</div>
              <div class="row" style="margin-top: 17px">
                <span class="personalcenter2">{{ identname }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <div class="row">
            <div class="col-md-4">
              <div class="personalcenter4">
                <span style="font-size: 21px">{{ totalcount }}</span>
                <span style="font-size: 12px">总发布数</span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="personalcenter5">
                <span style="font-size: 21px">{{ rentcount }}</span>
                <span style="font-size: 12px">在租数</span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="personalcenter6">
                <span style="font-size: 21px">{{ havetorent }}</span>
                <span style="font-size: 12px">已租数</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row personalcenter3" style id="toliulangg">
        <div class="col-md-12" style="text-align: center">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="我的房源" name="first">
              <div
                class="container"
                style="margin-top: 35px"
                v-loading="loadshow"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.1)"
              >
                <div
                  class="row houseList1"
                  style
                  v-for="todo in tableData"
                  @click="tohouseDetail(todo.id)"
                >
                  <div class="col-md-3" style>
                    <img
                      :src="todo.imgurl"
                      alt
                      class="houseList2"
                      style
                      srcset
                    />
                  </div>
                  <div class="col-md-4" style="text-align: left">
                    <div class="row">
                      <div class="col-md-12" style="font-size: 20px">
                        {{ todo.village_name }}{{ todo.building_no }}号{{
                          todo.room_no
                        }}室
                      </div>
                    </div>
                    <div class="row" style="margin-top: 23px">
                      <div class="col-md-12" style="color: #716f6f">
                        {{ todo.room }} 室 {{ todo.hall }} 厅
                        {{ todo.bathrooms }} 卫
                      </div>
                    </div>
                    <div class="row" style="margin-top: 23px">
                      <div
                        v-if="todo.subway"
                        class="col-md-12"
                        style="color: #716f6f"
                      >
                        {{ todo.area }} | {{ todo.subway }} 号线 -
                        {{ todo.station }} | {{ todo.size }} m²
                      </div>
                      <div v-else class="col-md-12" style="color: #716f6f">
                        {{ todo.area }} | 暂无地铁 | {{ todo.size }} m²
                      </div>
                    </div>
                    <div class="row" style="margin-top: 38px">
                      <div class="col-md-12" style="color: #716f6f">
                        <img
                          src="../assets/images/time.svg"
                          alt
                          style="width: 23px"
                          srcset
                        />
                        <span class="houseList3" style>{{
                          todo.created_at
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5" style>
                    <div class="row" style="margin-top: 33px">
                      <div
                        class="col-md-12"
                        style="color: #0f7ce2; font-size: 24px"
                      >
                        ¥ {{ todo.rental }}
                      </div>
                    </div>
                    <div class="row" style="margin-top: 10px">
                      <div class="col-md-12" style>
                        <span style="color: red">{{ todo.commission }}</span
                        >%佣金
                      </div>
                    </div>
                    <div class="row" style="margin-top: 10px">
                      <div class="col-md-12" style>
                        <span style="color: red" v-if="todo.status == 1"
                          >在租</span
                        >
                        <span style="color: #31b573" v-if="todo.status == 0"
                          >已租</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col-md-12"
                      style="
                        margin-top: 38px;
                        text-align: left;
                        margin-left: 23px;
                      "
                    >
                      <span
                        class="personalcenter7"
                        v-if="todo.status == 0"
                        @click.stop="updatestatus(todo.id, todo.status)"
                        >重新上架</span
                      >
                      <span
                        class="personalcenter7"
                        v-if="todo.status == 1"
                        @click.stop="updatestatus(todo.id, todo.status)"
                        >下架</span
                      >
                      <span
                        class="personalcenter8"
                        @click.stop="editHouse(todo.id)"
                        >编辑</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="container">
                <div class="row" style="margin-top: 75px; margin-bottom: 43px">
                  <div class="col-md-12">
                    <el-pagination
                      background
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="currentPage"
                      :page-size="PageSize"
                      layout="prev, pager, next"
                      :total="totalCount"
                    ></el-pagination>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="个人资料" name="second">
              <div class="container" style="margin-bottom: 42%">
                <div
                  class="row"
                  style="margin-top: 22px; display: flex; align-items: center"
                >
                  <div class="col-md-4" style="text-align: right">头像 :</div>
                  <div class="col-md-8" style="text-align: left">
                    <img :src="userimg" alt class="personalcenter1copy" />
                  </div>
                </div>
                <div class="row" style="margin-top: 22px">
                  <div class="col-md-4" style="text-align: right">姓名 :</div>
                  <div class="col-md-8" style="text-align: left">
                    {{ username }}
                  </div>
                </div>
                <div class="row" style="margin-top: 22px">
                  <div class="col-md-4" style="text-align: right">身份 :</div>
                  <div class="col-md-8" style="text-align: left">
                    {{ identname }}
                  </div>
                </div>
                <div class="row" style="margin-top: 22px">
                  <div class="col-md-4" style="text-align: right">电话 :</div>
                  <div class="col-md-8" style="text-align: left">
                    {{ userphone }}
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="推荐奖励" name="three">
              <div class="container" style="margin-bottom: 42%">
                <div class="row" style>
                  <el-table :data="tuijianData" style="width: 100%">
                    <el-table-column
                      prop="username"
                      label="我推荐的职业房东"
                      width="180"
                    ></el-table-column>
                    <el-table-column
                      prop="recommend_house_count"
                      label="他(她)发布房源数量"
                      width="180"
                    ></el-table-column>
                    <el-table-column
                      prop="money"
                      label="我将获得奖励金(元)"
                    ></el-table-column>
                  </el-table>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="我的钱包" name="four">
              <div class="container" style="margin-bottom: 42%">
                <div
                  class="row jianglimoney"
                  style="margin-top: 22px; display: flex; align-items: center"
                >
                  <span>我的余额</span>
                  <span class="jianglimoney1">{{ mymoney }} 元</span>
                  <span class="jianglimoney2" @click="openmoney">提现</span>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane v-if="is_company == 1" label="我的登盘" name="five">
              <el-table
                :data="mycount"
                :row-class-name="tableRowClassName"
                border
                style="width: 100%"
              >
                <el-table-column
                  prop="today"
                  label="今天"
                  width="180"
                ></el-table-column>
                <el-table-column
                  prop="yesterday"
                  label="昨天"
                  width="180"
                ></el-table-column>
                <el-table-column prop="week" label="本周"></el-table-column>
                <el-table-column prop="month" label="本月"></el-table-column>
                <el-table-column prop="l_month" label="上月"></el-table-column>
              </el-table>
              <p style="margin: 20px 0; text-align: left">我的登盘：</p>
              <el-table
                class="table_mycount"
                :data="my_release"
                style="width: 100%"
                border
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="house_num"
                  label="编号"
                  width="180"
                ></el-table-column>
                <el-table-column
                  prop="village_name"
                  label="小区名字"
                  width="200"
                ></el-table-column>
                <el-table-column
                  prop="building_no"
                  label="楼号"
                ></el-table-column>
                <el-table-column prop="room_no" label="房号"></el-table-column>
                <el-table-column
                  prop="size"
                  label="户型面积/m²"
                ></el-table-column>
                <el-table-column
                  prop="rental"
                  label="价格 ￥"
                ></el-table-column>
              </el-table>
              <el-pagination
                @current-change="changeRelease"
                :page-size="pageRelease"
                layout="total, prev, pager, next"
                :total="alltotal"
              >
              </el-pagination>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import https from "../http.js";
import qs from "qs";
export default {
  inject: ["reload"],

  data() {
    return {
      activeName: "first",
      // 总数据
      tableData: [],
      // 默认显示第几页
      currentPage: 1,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount: 1,
      // 个数选择器（可修改）

      // 默认每页显示的条数（可修改）
      PageSize: 10,
      loadshow: true,
      totalcount: "",
      rentcount: "",
      havetorent: "",
      username: "",
      identname: "",
      userimg: "",
      userphone: "",
      tuijianData: [],
      mymoney: "",
      mycount: [],
      // 发布的信息
      my_release: [],
      // 发布的信息分页
      // 发布总页
      defaultPageSize: 10,
      pageSizeLimit: [],
      pageRelease: 15,
      alltotal: 0,
      isPage: 1,
      //是否为内部员工
      is_company: "",
    };
  },

  created() {
    this.getData(this.PageSize, this.currentPage);
    this.getplease(this.isPage);
    // var userid = sessionStorage.getItem("userid");
    var userid = this.$cookies.get("userid");
    var param = {
      user_id: userid,
    };
    https
      .fetchPost("/personal-center/personal-data", qs.stringify(param))
      .then((data) => {
        //this.tableData.push(data.data.houseList.data)
        console.log(data);
        this.totalcount = data.data.user_data.total_count;
        this.rentcount = data.data.user_data.rent_count;
        this.havetorent = data.data.user_data.havetorent;
        this.username = data.data.user_data.username;
        this.mymoney = data.data.user_data.wallet;
        this.userphone = data.data.user_data.phone;
        this.identname = data.data.user_data.identityId.name;
        this.userimg =
          "https://www.zhiyefangdong.com/uploads/avatarimg/" +
          data.data.user_data.avatarimg;
        this.is_company = data.data.user_data.is_company;
        console.log(data);

        //console.log();
      })
      .catch((err) => {
        console.log(err);
      });

    https
      .fetchPost("/personal-center/referral-bonuses", qs.stringify(param))
      .then((data) => {
        //this.tableData.push(data.data.houseList.data)
        console.log(data.data.data);
        this.tuijianData = data.data.data;

        //console.log();
      })
      .catch((err) => {
        console.log(err);
      });
  },

  methods: {
    sizeRelease(e) {
      console.log(e);
    },
    changeRelease(e) {
      console.log(e);
      this.getplease(e);
    },
    getplease(n1) {
      // var userid = sessionStorage.getItem("userid");
      var userid = this.$cookies.get("userid");
      var pages = n1;
      var param = {
        user_id: userid,
        page: n1,
      };
      // 获取个人发布数量
      https
        .fetchPost("/personal-center/releases-count", qs.stringify(param))
        .then((data) => {
          console.log(data, "发布山谷里");
          this.my_release = data.data.house_data;
          this.mycount.push(data.data.releasescount);
          this.pageSizeLimit = data.data.page.pageSizeLimit;
          this.alltotal = Number(data.data.count);
        });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 表格颜色
    tableRowClassName({ row, rowIndex }) {
      return "success-row";
    },
    tohouseDetail(id) {
      //alert(id)
      this.$router.push({ path: "/HouseDetail", query: { houseid: id } });
    },

    openmoney() {
      this.$alert(
        "提现请联系微信15214389717或者电话联系15214389717",
        "联系我们",
        {
          confirmButtonText: "确定",
          callback: (action) => {},
        }
      );
    },

    updatestatus(id, status) {
      console.log(id, status);

      var param = {
        house_id: id,
        status: status,
      };

      https
        .fetchPost("/personal-center/up-or-down", qs.stringify(param))
        .then((data) => {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.reload();
          console.log(data);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    editHouse(id) {
      this.$router.push({ path: "/HouseEdit", query: { house_id: id } });
      //alert(id)
    },

    // 分页
    // 每页显示的条数
    handleSizeChange(val) {
      // 改变每页显示的条数
      this.PageSize = val;
      // 点击每页显示的条数时，显示第一页
      this.getData(val, 1);
      // 注意：在改变每页显示的条数时，要将页码显示到第一页
      this.currentPage = 1;
    },
    // 显示第几页
    handleCurrentChange(val) {
      // 改变默认的页数
      console.log(val);
      this.currentPage = val;
      this.loadshow = true;
      // 切换页码时，要获取每页显示的条数
      this.getData(this.PageSize, val * this.pageSize);
      document.querySelector("#toliulangg").scrollIntoView();
      //window.location.href = "#toliulang";
    },

    // 将页码，及每页显示的条数以参数传递提交给后台
    async getData(n1, n2) {
      var useridd = this.$cookies.get("userid");
      // var useridd = sessionStorage.getItem("userid");

      var param = {
        size: n1,
        page: this.currentPage,
        user_id: useridd,
      };

      await https
        .fetchGet("/personal-center/my-house", param)
        .then((data) => {
          //this.tableData.push(data.data.houseList.data)
          this.tableData = data.data.house_info;

          console.log(data);
          // 将数据的长度赋值给totalCount
          this.totalCount = parseInt(data.data.pages.totalCount);

          //console.log();
        })
        .catch((err) => {
          console.log(err);
        });

      this.loadshow = false;
    },
  },
};
</script>
<style src="../assets/css/bootstrap.min.css" scoped></style>
<style>
.el-table .success-row {
  background: #f0f9eb;
}
.el-tabs__item {
  padding: 0 20px;
  height: 40px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 40px;
  display: inline-block;
  list-style: none;
  font-size: 17px !important;
  font-weight: 500;
  color: #303133;
  position: relative;
}

body {
  overflow-y: scroll;
}
</style>
<style scoped>
.table_mycount {
  margin-bottom: 20px;
}
.houseList1 {
  border-bottom: 1px solid #f5eded;
  padding-bottom: 21px;
  margin-top: 28px;
}

.el-tabs__item is-top {
  font-size: 18px;
}

.jianglimoney {
  margin-top: 22px;
  display: flex;
  flex-direction: column;
}

.jianglimoney1 {
  margin-top: 44px;
  font-size: 29px;
  color: red;
}

.jianglimoney2 {
  margin-top: 100px;
  background: #000;
  color: #fff;
  padding: 8px 25px;
  cursor: pointer;
}

.houseList2 {
  width: 95%;
  height: 180px;
  object-fit: cover;
  border-radius: 13px;
}

.houseList3 {
  margin-left: 12px;
  margin-top: 5px;
  position: absolute;
  font-size: 14px;
}

.houseList4 {
  padding: 5px 10px;
  border-radius: 3px;
  background: #0e86e2;
  color: #fff;
}

.houseList5 {
  display: flex;
  align-items: center;
}

.houseList6 {
  display: flex;
  align-items: flex-start;
}

.personalcenter1 {
  width: 75px;
  height: 75px;
  border-radius: 50%;
}

.personalcenter1copy {
  width: 51px;
  height: 51px;
  border-radius: 50%;
}

.personalcenter2 {
  background: #000;
  color: #fff;
  padding: 2px 15px;
}

.personalcenter3 {
  width: 100%;
  margin: 0 auto;
  margin-top: 144px;
}

.personalcenter4 {
  display: flex;
  flex-direction: column;
  border: 2px solid #1268d3;
  border-radius: 50%;
  width: 99px;
  height: 99px;
  padding-top: 21px;
}

.personalcenter5 {
  display: flex;
  flex-direction: column;
  border: 2px solid #f74128;
  border-radius: 50%;
  width: 99px;
  height: 99px;
  padding-top: 21px;
}

.personalcenter6 {
  display: flex;
  flex-direction: column;
  border: 2px solid #31b573;
  border-radius: 50%;
  width: 99px;
  height: 99px;
  padding-top: 21px;
}

.personalcenter7 {
  background: #000;
  color: #fff;
  border-radius: 5px;
  padding: 5px 10px;
  cursor: pointer;
}

.personalcenter8 {
  background: #000;
  color: #fff;
  border-radius: 5px;
  padding: 5px 10px;
  margin-left: 34px;
  cursor: pointer;
}
</style>
